<template>
  <div class="generate-codes">
    <div class="container padding-top-90">
      <div class="row mb-3">
        <div class="col-auto">
          <div class="form-group">
            <fieldset :disabled="creating">
              <select name="currentEvent" class="form-control" v-model="currentEvent" @change="currentEventChanged">
                <option :value="null">Select event</option>
                <option :value="event.id" v-for="event in events" :key="`eventSelect-${event.id}`">{{ event.header }}</option>
              </select>
            </fieldset>
            <!-- <a href="javascript:;" @click="changeEventOnCodes">Hej</a> -->
          </div>
        </div>
        <div class="col" v-if="!loading && currentEvent">
          <form name="form" class="form form-horizontal" @submit.prevent="createCodes">
            <fieldset :disabled="creating">
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <input type="number" name="numberOfCodes" v-model="numberOfCodes" class="form-control" placeholder="Number of codes">
                  </div>
                </div>
                <div class="col-6">
                  <button type="submit" class="btn btn-success">Create<span v-if="numberOfCodes"> {{ numberOfCodes }} codes</span></button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
        <div class="col text-right" v-if="!loading && currentEvent">
          <button type="button" class="btn btn-danger mr-1" @click="removeAllCodes">Remove ALL event codes</button>
          <button type="button" class="btn btn-secondary" @click="downloadCsv">Download event CSV file</button>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <strong>Number of codes:</strong> {{ codes.length }}
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Code</th>
                <th>Event ID</th>
                <th>Used?</th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="loading">
              <tr>
                <td colspan="4" class="text-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-if="codes.length == 0 && !currentEvent">
                <td colspan="4" class="text-center">Select event</td>
              </tr>
              <tr v-if="codes.length == 0 && currentEvent">
                <td colspan="4" class="text-center">No codes created for event {{ currentEvent.header }}</td>
              </tr>
              <tr v-for="code in codes" :key="code.id">
                <td class="align-middle">{{ code.id }}</td>
                <td class="align-middle">{{ code.eventId }}</td>
                <td class="align-middle">{{ translator[code.used.toString()] }}</td>
                <td class="align-middle text-right">
                  <button type="button" class="btn btn-danger mr-1" @click="removeCode(code)">Remove</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"
  import { range, sampleSize } from "lodash"

  export default {
    name: "generate-codes",
    beforeRouteEnter(to, from, next) {
      if(to.query.showme) {
        next()
      } else {
        next({ name: "home" })
      }
    },
    data() {
      return {
        loading: true,
        creating: false,
        events: [],
        codes: [],
        currentEvent: null,
        numberOfCodes: null,
        translator: {
          "true": "Yes",
          "false": "No"
        }
      }
    },
    computed: {
      event() {
        return this.events.find((event) => event.id == this.currentEvent)
      }
    },
    methods: {
      async currentEventChanged() {
        this.loading = true
        await this.getCodes()
        this.loading = false
      },
      downloadCsv() {
        let rows = [["Code", "Event", "Used"]]
        this.codes.forEach((code) => rows.push([code.id, code.eventId, this.translator[code.used.toString()]]))

        let csvContent = "data:text/csv;charset=utf-8," + rows.map(row => row.join(",")).join("\n");

        let encodedUri = encodeURI(csvContent)
        let link = document.createElement("a")
        link.setAttribute("href", encodedUri)
        link.setAttribute("download", "participation-codes.csv")
        link.click()
      },
      async generateCode() {
        return new Promise((resolve) => {
          (async () => {
            let characters = [
              "A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
              "a", "b", "c", "d", "e", "f", "g", "h", "j", "k", "m", "n", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z",
              0, 2, 3, 4, 5, 6, 7, 8, 9
            ]

            let codeString = sampleSize(characters, 8).join("")

            let codeRef = await firebase.firestore().collection(`codes`).doc(codeString)
            let code = await codeRef.get()

            if(code.exists) {
              await this.generateCode()
            } else {
              resolve(codeString)
            }
          })()
        })
      },
      async createCodes() {
        this.creating = true
        let batch = firebase.firestore().batch()
        let codesRange = range(Number(this.numberOfCodes))

        let count = 1

        for(let index of codesRange) {
          let code = await this.generateCode(index)
          let codeRef = await firebase.firestore().collection(`codes`).doc(code)

          if(count == 500) {
            await batch.commit()
            batch = firebase.firestore().batch()

            count = 1
          }

          batch.set(codeRef, {
            eventId: this.currentEvent,
            used: false,
            currentUser: ""
          })

          count = count + 1
        }

        await batch.commit()

        this.creating = false
      },
      async removeAllCodes() {
        let remove = confirm(`ARE YOU SURE?\nTHIS WILL REMOVE ${this.codes.length} CODES!\nTHIS CAN'T BE UNDONE!`)

        if(remove) {
          this.loading = true
          let batch = firebase.firestore().batch()

          let count = 1

          for(let code of this.codes) {
            let codeRef = await firebase.firestore().collection(`codes`).doc(code.id)

            console.log(`Removing ${code.id} ...`)

            if(count == 500) {
              console.log(`Committing batch ...`)

              await batch.commit()
              batch = firebase.firestore().batch()

              count = 1
            }

            batch.delete(codeRef)

            count = count + 1
          }

          await batch.commit()

          this.loading = false
        }
      },
      async removeCode(code) {
        let remove = confirm(`ARE YOU SURE?\nTHIS CAN'T BE UNDONE!`)

        if(remove) {
          this.creating = true
          await firebase.firestore().collection(`codes`).doc(code.id).delete()
          this.creating = false
        }
      },
      async changeEventOnCodes() {
        this.loading = true
        let eventId = "interior-trend-spring-summer-2022"
        let batch = firebase.firestore().batch()

        let codesQuery = await firebase.firestore().collection(`codes`).where("eventId", "==", eventId).get()
        let codes = codesQuery.docs

        let count = 1

        for (let code of codes) {
          let codeRef = await firebase.firestore().collection(`codes`).doc(code.id)

          if(count == 500) {
            await batch.commit()
            batch = firebase.firestore().batch()

            count = 1
          }

          batch.update(codeRef, { eventId: "interior-trend" })

          count = count + 1
        }

        await batch.commit()

        this.loading = false
      },
      async getCodes() {
        return new Promise((resolve, reject) => {
          (async () => {
            try {
              if(this.event) {
                if(this.$firestoreRefs["codes"]) { this.$unbind("codes", true) }
                await this.$bind("codes", firebase.firestore().collection(`codes`).where("eventId", "==", this.event.id))
              }

              resolve()
            } catch(error) {
              reject(error)
            }
          })()
        })
      }
    },
    async mounted() {
      let eventsRef = await firebase.firestore().collection(`events`).where("active", "==", true).orderBy("eventStart")
      let events = await eventsRef.get()
      this.events = await events.docs.map((doc) => {
        return Object.assign({}, { id: doc.id }, doc.data())
      })

      await this.getCodes()
      this.loading = false
    }
  }
</script>

<style lang="scss" scoped>
  
</style>